import React, { FunctionComponent } from 'react'
import { Route, Routes } from 'react-router-dom'

import { ProtectedRoutes } from '../../../authentication'
import { BillingManager } from '../billing'
import { PolicyTabs } from '../configuration'

export const PolicyEndedRoutes: FunctionComponent = () => (
  <ProtectedRoutes>
    <BillingManager>
      <Routes>
        <Route path='*' element={<PolicyTabs />} />
      </Routes>
    </BillingManager>
  </ProtectedRoutes>
)
